// Global safety net: prevent any .quick-close button from submitting a form,
// regardless of how the HTML was rendered (e.g. SearchSpring templates).
document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.quick-close');
  if (closeBtn && closeBtn.closest('form')) {
    e.preventDefault();
  }
}, true); // capture phase — fires before any other handlers

if (window.matchMedia('(min-width: 1024px)').matches) {
  function initQuickAddComponent(scope = document) {
    scope.querySelectorAll('.quick-add-component').forEach(component => {
      if (component.dataset.bound === 'true') return;
      component.dataset.bound = 'true';

      const chooseBtn = component.querySelector('.quick-add__button_desktop');
      const modal = component.querySelector('.quick-add-modal-desktop');
      const form = component.querySelector('form');
      const submitBtn = component.querySelector('.quick-add__button--submit');
      const realAddBtn = component.querySelector('.quick-add__button--add');
      const quickCloseBtn = component.querySelector('.quick-close'); 

      if (!chooseBtn || !modal || !form || !submitBtn || !realAddBtn) return;

      chooseBtn.addEventListener('click', e => {
        e.preventDefault();
        modal.classList.toggle('open');
      });

      // Close modal on quick-close button click
      if (quickCloseBtn) {
        quickCloseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (modal.classList.contains('open')) {
            modal.classList.remove('open');
            submitBtn.disabled = true;
            submitBtn.textContent = 'Select Size';
            form.reset();
          }
        });
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Select Size';

      form.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', () => {
          const selected = form.querySelector('input[type="radio"]:checked');
          if (!selected) return;

          // Find the label for this radio
          const label = form.querySelector(`label[for="${selected.id}"]`) || selected.closest('label');

          if (label && label.classList.contains('notify-me')) {
            // Just enable submit but DO NOT auto-submit
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Bag';
            return;
          }

          // For all other labels, enable and auto-submit
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to Bag';
          submitBtn.click();
        });
      });


      // Prevent native form submission — use AJAX via globalAddToCart instead
      form.addEventListener('submit', e => {
        e.preventDefault();
      });

      submitBtn.addEventListener('click', e => {
        if (submitBtn.disabled) {
          e.preventDefault();
          return;
        }

        const selectedRadio = form.querySelector('input[type="radio"]:checked');
        if (!selectedRadio || !selectedRadio.value) return;

        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';

        if (window.globalAddToCart) {
          window.globalAddToCart({ variantId: selectedRadio.value, quantity: 1 });
        } else {
          realAddBtn.click();
        }

        setTimeout(() => {
          modal.classList.remove('open');
          submitBtn.disabled = true;
          submitBtn.textContent = 'Select Size';
          form.reset();
        }, 800);
      });

      document.addEventListener('click', e => {
        const isClickInside = component.contains(e.target);
        const isChooseButton = chooseBtn.contains(e.target);

        if (!isClickInside && !isChooseButton && modal.classList.contains('open')) {
          modal.classList.remove('open');
          submitBtn.disabled = true;
          submitBtn.textContent = 'Select Size';
          form.reset();
        }
      });
    });
  }
}

// 1. Init on DOM ready (PLP/initial load)
document.addEventListener('DOMContentLoaded', () => {
  const initialGrids = document.querySelectorAll('.product-grid, .resource-list');
  initialGrids.forEach(grid => initQuickAddComponent(grid));
});

// 2. Observe for dynamic content (e.g. PDP recommendations)
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;

      if (
        node.matches('.product-grid, .resource-list.with_quick_add') ||
        node.querySelector('.quick-add-component')
      ) {
        initQuickAddComponent(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

// 3. Listen for Shopify recommendation system flag
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target || e.detail?.section;
  if (section) initQuickAddComponent(section);
});

// 4. Fallback if `data-recommendations-performed` is set
const checkRecommendationsLoaded = setInterval(() => {
  const container = document.querySelector('.resource-list[data-recommendations-performed="true"]');
  if (container) {
    initQuickAddComponent(container);
    clearInterval(checkRecommendationsLoaded);
  }
}, 200);


// Mobile Quick to Add **********************************************************************/

/* Only run on mobile screens (max-width: 1023px)
if (window.matchMedia('(max-width: 1023px)').matches) {
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.quick-add__button_mobile');
    if (!trigger) return;

    const modalContent = document.getElementById('quick-add-modal-content');

    if (!modalContent) return;

    // Create a MutationObserver to wait for injected content
    const observer = new MutationObserver((mutations, obs) => {
      if (modalContent.children.length === 0) return;

      const modal = modalContent;

      // Prevent double-initializing
      if (modal.dataset.quickAddInitialized === 'true') {
        obs.disconnect();
        return;
      }
      modal.dataset.quickAddInitialized = 'true';

      const legend = modalContent.querySelector('legend');
      if (legend && legend.textContent.trim() === 'Size') {
        legend.textContent = 'Quick Add';
        observer.disconnect(); // Stop once it's done
      }

      const button = modal.querySelector('add-to-cart-component button');
      const textContent = modal.querySelector('.add-to-cart-text__content');
      let sizeRadios = modal.querySelectorAll('.size-box input[type="radio"]');

      if (!button || !textContent || sizeRadios.length === 0) {
        obs.disconnect();
        return;
      }

      // Force-remove "checked" state by cloning
      sizeRadios.forEach(original => {
        const clone = original.cloneNode(true);
        clone.checked = false;
        original.parentNode.replaceChild(clone, original);
      });

      // Refresh radio list after cloning
      sizeRadios = modal.querySelectorAll('.size-box input[type="radio"]');

      // Initial state
      textContent.textContent = 'Select Size';
      //button.disabled = true;
      button.classList.add('disabled');

      // Enable on selection
      sizeRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            textContent.textContent = 'Add to Bag';
            //button.disabled = false;
            button.classList.remove('disabled');
          }
        });
      });

      // Done observing after init
      obs.disconnect();
    });

    // Start observing the modal content
    observer.observe(modalContent, {
      childList: true,
      subtree: true,
    });
  });
}
*/

if (window.matchMedia('(max-width: 1023px)').matches) {
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.quick-add__button_desktop');
    if (!trigger) return;

    // Ignore clicks inside the already-open modal/dialog:
    if (trigger.closest('#quick-add-dialog')) return;

    const quickAddComponent = trigger.closest('.quick-add-component');
    if (!quickAddComponent) return;

    // Clone the quick-add-component
    const clone = quickAddComponent.cloneNode(true);

    // Check if dialog exists, create if not
    let dialogWrapper = document.getElementById('quick-add-dialog');
    if (!dialogWrapper) {
      dialogWrapper = document.createElement('quick-add-dialog');
      dialogWrapper.id = 'quick-add-dialog';

      const dialog = document.createElement('dialog');
      dialog.className = 'quick-add-modal dialog-modal color-scheme-1';
      dialog.setAttribute('ref', 'dialog');
      dialog.setAttribute('scroll-lock', '');

      const modalContentWrapper = document.createElement('div');
      modalContentWrapper.id = 'quick-add-modal-content';
      modalContentWrapper.className = 'quick-add-modal__content';

      dialog.appendChild(modalContentWrapper);
      dialogWrapper.appendChild(dialog);
      document.body.appendChild(dialogWrapper);
    }

    // Inject clone inside existing modal content (replace existing)
    const modalContentWrapper = dialogWrapper.querySelector('#quick-add-modal-content');
    modalContentWrapper.innerHTML = ''; // Clear old content
    modalContentWrapper.appendChild(clone);

    // Show the dialog
    const dialog = dialogWrapper.querySelector('dialog');
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    dialog.scrollIntoView({ behavior: 'smooth' });

    // Initialize event listeners on cloned component inside modal
    waitForFormAndButtons(clone, (form, submitBtn, realAddBtn, quickCloseBtn) => {
      console.log('Form and buttons found!');
      setupQuickAddListeners(form, submitBtn, realAddBtn, clone, quickCloseBtn);
    });
  });
}


function waitForFormAndButtons(component, callback) {
  const interval = setInterval(() => {
    const form = component.querySelector('form');
    const submitBtn = component.querySelector('.quick-add__button--submit');
    const realAddBtn = component.querySelector('.quick-add__button--add');
    const quickCloseBtn = component.querySelector('.quick-close');
    if (form && submitBtn && realAddBtn) {
      clearInterval(interval);
      callback(form, submitBtn, realAddBtn, quickCloseBtn);
    }
  }, 100);
}

function setupQuickAddListeners(form, submitBtn, realAddBtn, component, quickCloseBtn) {
  const dialogAncestor = component.closest('dialog');

  if (dialogAncestor) {
    // Close when clicking outside the dialog content
    dialogAncestor.addEventListener('click', (e) => {
      const content = dialogAncestor.querySelector('.quick-add-component');
      if (!content.contains(e.target)) {
        dialogAncestor.close();
      }
    });

    // Close event resets state
    dialogAncestor.addEventListener('close', () => {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Select Size';
      form.reset();
      form.querySelectorAll('.size-box.selected').forEach(lbl => lbl.classList.remove('selected'));
    });

    if (quickCloseBtn) {
      quickCloseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        dialogAncestor.close();
      });
    }
  }


  submitBtn.disabled = true;
  submitBtn.textContent = 'Select Size';

  // Use label click to toggle selected class and enable button
  form.querySelectorAll('.size-box').forEach(label => {
    label.addEventListener('click', () => {
      // If the clicked label is a notify-me, close dialog immediately
      if (label.classList.contains('notify-me')) {
        if (dialogAncestor && typeof dialogAncestor.close === 'function') {
          dialogAncestor.close();
        }
        return;
      }

      // Remove selected from others
      form.querySelectorAll('.size-box').forEach(l => l.classList.remove('selected'));

      // Add selected to clicked
      label.classList.add('selected');

      // Enable submit button
      submitBtn.disabled = false;
      submitBtn.textContent = 'Add to Bag';

      // For debug, log selected variant ID from the radio inside label
      const radio = label.querySelector('input[type="radio"]');
      console.log('Selected variant ID:', radio?.value);

      // **Auto-trigger submit button click here**
      submitBtn.click();
    });
  });

  // Prevent native form submission — use AJAX via globalAddToCart instead
  form.addEventListener('submit', e => {
    e.preventDefault();
  });

  submitBtn.addEventListener('click', e => {
    if (submitBtn.disabled) {
      e.preventDefault();
      return;
    }

    const selectedRadio = form.querySelector('input[type="radio"]:checked');
    if (!selectedRadio || !selectedRadio.value) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    if (window.globalAddToCart) {
      window.globalAddToCart({ variantId: selectedRadio.value, quantity: 1 });
    } else {
      realAddBtn.click();
    }

    setTimeout(() => {
      if (dialogAncestor && typeof dialogAncestor.close === 'function') {
        dialogAncestor.close();
      }
      submitBtn.disabled = true;
      submitBtn.textContent = 'Select Size';
      form.reset();
      // Remove selected classes
      form.querySelectorAll('.size-box.selected').forEach(lbl => lbl.classList.remove('selected'));
    }, 800);
  });
}


// Lookbook Quick
document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.quick-add__button_lookbook');
    if (!trigger) return;

    // Ignore clicks inside the already-open modal/dialog:
    if (trigger.closest('#quick-add-dialog')) return;

    const quickAddComponent = trigger.closest('.quick-add-component');
    if (!quickAddComponent) return;

    // Clone the quick-add-component
    const clone = quickAddComponent.cloneNode(true);

    // Check if dialog exists, create if not
    let dialogWrapper = document.getElementById('quick-add-dialog');
    if (!dialogWrapper) {
      dialogWrapper = document.createElement('quick-add-dialog');
      dialogWrapper.id = 'quick-add-dialog-lookbook';

      const dialog = document.createElement('dialog');
      dialog.className = 'quick-add-modal dialog-modal color-scheme-1 quick-add-modal-lookbook';
      dialog.setAttribute('ref', 'dialog');
      dialog.setAttribute('scroll-lock', ''); 

      const modalContentWrapper = document.createElement('div');
      modalContentWrapper.id = 'quick-add-modal-content';
      modalContentWrapper.className = 'quick-add-modal__content';

      dialog.appendChild(modalContentWrapper);
      dialogWrapper.appendChild(dialog);
      document.body.appendChild(dialogWrapper);
    }

    // Inject clone inside existing modal content (replace existing)
    const modalContentWrapper = dialogWrapper.querySelector('#quick-add-modal-content');
    modalContentWrapper.innerHTML = ''; // Clear old content
    modalContentWrapper.appendChild(clone);

    // Show the dialog
    const dialog = dialogWrapper.querySelector('dialog');
    dialog.classList.add('quick-add-modal-lookbook');
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    dialog.scrollIntoView({ behavior: 'smooth' });

    // Initialize event listeners on cloned component inside modal
    waitForFormAndButtons(clone, (form, submitBtn, realAddBtn, quickCloseBtn) => {
      console.log('Form and buttons found!');
      setupQuickAddListeners(form, submitBtn, realAddBtn, clone, quickCloseBtn);
    });
});











